import { render } from "./agentProportionModal.vue?vue&type=template&id=6e862a40&scoped=true"
import script from "./agentProportionModal.vue?vue&type=script&lang=js"
export * from "./agentProportionModal.vue?vue&type=script&lang=js"

import "./agentProportionModal.vue?vue&type=style&index=0&id=6e862a40&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e862a40"]])

export default __exports__